import { useState } from "react";

export type ReferralFilterState = {
    archived: boolean;
    therapyCategoryIds: string[];
};

const defaultFilters: ReferralFilterState = {
    archived: false,
    therapyCategoryIds: []
};

export const useReferralFilters = () => {
    const [filters, setFilters] = useState<ReferralFilterState>(defaultFilters);

    return { filters, setFilters };
};
